import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CkycDocumentsComponent } from 'src/app/ckyc-maruti-documents/ckyc-documents.component';
import { CkycDocumentsRoutingModule } from 'src/app/ckyc-maruti-documents/ckyc-documents.routing';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AuthGuard } from '../login/auth.guard';
import { ToUppercaseModule } from '../common/directives/to-uppercase.module';

@NgModule({
    imports: [
        CommonModule,
        CkycDocumentsRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule.forRoot(),
        ToUppercaseModule
    ],
    declarations: [
        CkycDocumentsComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [AuthGuard]
})
export class CkycDocumentsModule { }
